import { inject, Injectable } from '@angular/core';
import { APP_CONFIG, LanguageService } from '../core';


/**
 * This service handles cookie banner.
 */
@Injectable({ providedIn: 'root' })
export class CookieBannerService {

	private readonly configs = inject(APP_CONFIG);
	private readonly langSrv = inject(LanguageService);

	/**
	 * Open cookie banner.
	 */
	openBanner(): void {
		this.langSrv.isLabelsLoaded.subscribe(() => {
			this.initConfig();
			this.updateLang();
			this.showBanner();
		});
	}

	private initConfig(): void {
		(globalThis as any)._iub = (globalThis as any)._iub || [];
		(globalThis as any)._iub.csConfiguration = this.DEFAULT_BANNER_CONFIG;

		const script: HTMLScriptElement = document.createElement('script');
		script.type = 'text/javascript';
		script.src = `https://cs.iubenda.com/autoblocking/${this.configs.cookieSiteId}.js`;
		document.getElementsByTagName('head')[0].appendChild(script);

		const script1: HTMLScriptElement = document.createElement('script');
		script1.type = 'text/javascript';
		script1.src = 'https://cdn.iubenda.com/cs/gpp/stub.js';
		document.getElementsByTagName('head')[0].appendChild(script1);
	}

	private updateLang(): void {
		(globalThis as any)._iub.csConfiguration.i18n = {
			...(globalThis as any)._iub.csConfiguration.i18n,
			[this.langSrv.currentLang]: {
				"banner": {
					"dynamic": {
						"body": this.langSrv.labels().COOKIE_BANNER_BODY_TEXT?.replace('{{legal-terms-site}}', this.configs.legalTermsSite)
					},
					"accept_button_caption": this.langSrv.labels().COOKIE_BANNER_ACCEPT_BTN,
					"reject_button_caption": this.langSrv.labels().COOKIE_BANNER_REJECT_BTN,
					"customize_button_caption": this.langSrv.labels().COOKIE_BANNER_CAPTION_BTN
				}
			}
		};
		(globalThis as any)._iub.csConfiguration.lang = this.langSrv.currentLang;
	}

	private showBanner(): void {
		const script: HTMLScriptElement = document.createElement('script');
		script.type = 'text/javascript';
		script.async = true;
		script.src = 'https://cdn.iubenda.com/cs/iubenda_cs.js';
		document.getElementsByTagName('head')[0].appendChild(script);
	}

	private get DEFAULT_BANNER_CONFIG() {
		return {
			"askConsentAtCookiePolicyUpdate": true,
			"cookiePolicyInOtherWindow": true,
			"countryDetection": true,
			"enableFadp": true,
			"enableLgpd": true,
			"enableUspr": true,
			"lang": "en",
			"lgpdAppliesGlobally": false,
			"perPurposeConsent": true,
			"purposes": "1,2",
			"reloadOnConsent": true,
			"siteId": this.configs.cookieSiteId,
			"cookiePolicyId": this.configs.cookiePolicyId,
			"cookiePolicyUrl": this.configs.legalTermsSite,
			"privacyPolicyUrl": this.configs.legalTermsSite,
			"privacyPolicyNoticeAtCollectionUrl": this.configs.legalTermsSite,
			"banner": {
				"acceptButtonDisplay": true,
				"closeButtonRejects": true,
				"customizeButtonDisplay": true,
				"explicitWithdrawal": true,
				"listPurposes": true,
				"position": "bottom",
				"rejectButtonDisplay": true,
				"showPurposesToggles": true
			}
		};
	}

}
